export function splitFileNameAndExtension(fileName: string): [string, string] {
  const fileNameParts = fileName.split('.');
  const fileNameWithoutExtension = fileNameParts.slice(0, -1).join('.');
  const fileExtension = fileNameParts.slice(-1)[0];
  return [fileNameWithoutExtension, fileExtension];
}
